import { Box, Step, StepLabel, Stepper, styled } from '@mui/material';

const stepLabels = ['Create revaluation', 'Approve action'];

const Container = styled(Box)({
  width: '400px',
});

type Props = {
  activeStep: number;
};

const BulkRevaluationsStepper: React.FC<Props> = ({ activeStep }) => (
  <Container>
    <Stepper activeStep={activeStep}>
      {stepLabels.map((label) => (
        <Step key={label}>
          <StepLabel>{label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  </Container>
);

export default BulkRevaluationsStepper;
